import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ChatMessageClient } from '../../ChatMessageClient';
export const IntakeCompleteAttachment = ({ message }) => {
    const attachment = message.attachments.find((el) => el.type === 'intake_complete');
    const { t } = useTranslation();
    const actions = [
        {
            type: 'fill-intake',
            data: {
                orderId: attachment === null || attachment === void 0 ? void 0 : attachment.id,
            },
        },
    ];
    const newMessage = Object.assign(Object.assign({}, message), { attachments: [], content: t('label.reminder_fill_intake') });
    return (_jsx(ChatMessageClient, { role: 'provider', message: newMessage, showTimestamp: false, actions: actions }));
};
